import { FeatureList } from './FeatureList';
import { GreenCheckIcon } from './icons';

export const PremiumFeaturesList = () => {
  return (
    <FeatureList
      items={[
        {
          icon: <GreenCheckIcon />,
          text: 'Connect unlimited clusters',
        },
        {
          icon: <GreenCheckIcon />,
          text: 'Unlock premium features',
        },
        {
          icon: <GreenCheckIcon />,
          text: 'No credit card required',
        },
      ]}
    />
  );
};
